// Хуки оболочки: перерисовка по транзакциям редактора, подписка на реестры и хосты.
import { useEffect, useReducer, useSyncExternalStore } from 'react';
import type { Editor } from '@tiptap/core';
import type { Registry } from '../core/registry';
import { useApp } from '../core/store';
import { onMiniTick } from '../core/editor/active';

/** Перерисовать компонент при каждой транзакции редактора (не чаще кадра). */
export function useEditorTick(): Editor | null {
  const editor = useApp((s) => s.editor);
  const [, bump] = useReducer((x: number) => x + 1, 0);
  useEffect(() => {
    if (!editor) return;
    let raf = 0;
    const on = () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(bump); };
    editor.on('transaction', on);
    const off = onMiniTick(on);
    return () => { editor.off('transaction', on); off(); cancelAnimationFrame(raf); };
  }, [editor]);
  return editor && !editor.isDestroyed ? editor : null;
}

/** Список элементов реестра с перерисовкой при изменении. */
export function useRegistry<T extends { id: string; order?: number }>(r: Registry<T>): T[] {
  return useSyncExternalStore((f) => r.subscribe(f), () => r.list());
}
